/* eslint-disable */
import dayjs from 'dayjs';
import { MONITOREOS_INTERNET } from 'constants/tipoMonitoreos';
import { MONITOREO_TERMINADO } from 'constants/estatusMonitoreo';
import { TIPO_ACCESO_WEB } from 'constants/tiposAcceso';
import { FORMAT_BACKEND, DATE_BACKEND_DAY, DATE_BACKEND_HOUR } from 'constants/dateFormat';

const findElementNomBene = (array, searchElement) => 
{
  if (array?.length !== undefined) 
  {
    // console.log('searchElement: ', searchElement);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < array.length; i++) 
    {
      const element = array[i];
      if (element.nombreBeneficiado === undefined || element.nombreBeneficiado === '' || element.nombreBeneficiado === null) 
      {
        // console.log('undefined');
        return null;
      }
      if (element.nombreBeneficiado === searchElement) 
      {
        // console.log('searchElement');
        return i;
      }
    }
  }
  return -1;
};

const eliminarObjetosDuplicadosPorPropiedad = (
  arr,
  propiedad1,
  propiedad2,
  propiedad3,
  propiedad4
) => {
  const objetoTemporal = {};

  return arr.filter((objeto) => {
    const valores = [
      objeto[propiedad1] ?? "NULL",
      objeto[propiedad2] ?? "NULL",
      objeto[propiedad3] ?? "NULL",
      objeto[propiedad4] ?? "NULL"
    ];

    const clave = JSON.stringify(valores);

    /*console.log("clave:", clave);
    console.log("Antes de asignar, objetoTemporal[clave]:", objetoTemporal[clave]);*/

    if (!objetoTemporal.hasOwnProperty(clave)) {
      objetoTemporal[clave] = true;
      // console.log("Después de asignar, objetoTemporal[clave]:", objetoTemporal[clave]);
      return true;
    }

    return false;
  });
};



export const newFormatBeneficiados = (
  beneficiados,
  catalogoBeneficiados,
  idProcesoEspecifico,
  beneficiadosOriginales,
  tipoBeneficio
) => {
  let beneficiadoTemp;

  let existeBenficiadoSujeto = false;

  // console.log('beneficiados: ', beneficiados);
  // console.log('beneficiadosOriginales: ', beneficiadosOriginales);

  const beneficiadosFormateados = beneficiados?.map((beneficiado, index) => 
  {
    if (beneficiado.beneficiado > 0) 
    {
      beneficiadoTemp =
        catalogoBeneficiados?.find((b) => b.idContabilidad === beneficiado.beneficiado) || {};
      const beneficiadoFormateado = {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado !== 0) 
    {
      existeBenficiadoSujeto = true;

      //console.log('beneficiado.sujetoObligado: ', beneficiado.sujetoObligado);
      //console.log('beneficiado.idTipoAsociacion: ', beneficiado.idTipoAsociacion);
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
               b.idProcesoSIMAC === idProcesoEspecifico
            && b.sujetoObligado    === beneficiado.sujetoObligado
            && b.idTipoAsociacion  === beneficiado.idTipoAsociacion
        ) || [];

      //console.log('beneficiadosTemporales: ', beneficiadosTemporales);

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo && b.sujetoObligado === beneficiado.sujetoObligado)
        : beneficiadosTemporales[0] || {};


        // console.log('beneficiadoTemp: ', beneficiadoTemp);

      if (beneficiadoTemp === undefined || Object.keys(beneficiadoTemp).length === 0) {
          const beneficiadoFormateado = {
            ...beneficiado,
            pkBeneficiado: index + 1,
          };
        
          // console.log("beneficiadoFormateado 1: ", beneficiadoFormateado);
          return beneficiadoFormateado;
      }
        
      const beneficiadoFormateado = 
      {
        ...beneficiadoTemp,
        pkBeneficiado: index + 1
      };

      // console.log('beneficiadoFormateado 2: ', beneficiadoFormateado);
      return beneficiadoFormateado;
    }


    if (beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado === 0) 
    {
      existeBenficiadoSujeto = false;
      // console.log('beneficiado.beneficiado === undefined && beneficiado.idSujetoObligado === 0: ')
      const beneficiadosTemporales =
        catalogoBeneficiados?.filter(
          (b) =>
             b.idProcesoSIMAC === idProcesoEspecifico 
          && b.idTipoAsociacion === beneficiado.idTipoAsociacion
        ) || [];

      beneficiadoTemp = beneficiado.cargo
        ? beneficiadosTemporales?.find((b) => b.cargo === beneficiado.cargo && b.sujetoObligado === beneficiado.sujetoObligado)
        : beneficiadosTemporales[0] || {};

      if (beneficiadoTemp === undefined) 
      {
        const beneficiadoFormateado = 
        {
            ...beneficiado
          , cargo: beneficiado.cargo
          , idSujetoObligado: beneficiado.idSujetoObligado
          , sujetoObligado: beneficiado.sujetoObligado
          , nombreBeneficiado: beneficiado.sujetoObligado
          , pkBeneficiado: index + 1
        };
        return beneficiadoFormateado;
      }
      const beneficiadoFormateado = 
      {
          ...beneficiadoTemp
        , idSujetoObligado: beneficiado.idSujetoObligado
        , sujetoObligado: beneficiado.sujetoObligado
        , pkBeneficiado: index + 1
      };
      return beneficiadoFormateado;
    }

    const beneficiadoFormateado = {
      ...beneficiado,
      pkBeneficiado: index + 1 // Dato arbitrario solicitado por el backend
    };
    return beneficiadoFormateado;
  });

  // console.log('beneficiadosFormateados 1: ', beneficiadosFormateados);

  let beneficiadosFormateadosSinDuplicidad;

  if (beneficiados?.length !== 0 && beneficiados[0].beneficiado === undefined) 
  {
    beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
      beneficiadosFormateados,
      'nombreBeneficiado',
      'idTipoAsociacion',
      'idContabilidad'
    );
  }

  beneficiadosFormateadosSinDuplicidad = eliminarObjetosDuplicadosPorPropiedad(
    beneficiadosFormateados,
    'nombreBeneficiado',
    'idTipoAsociacion',
    'idSujetoObligado',
    'cargo'
  );

  beneficiadosOriginales?.map((beneficiadoOriginal) => {
    let updatedBeneficiado = {};

    const index = findElementNomBene(
      beneficiadosFormateadosSinDuplicidad,
      beneficiadoOriginal.nombreBeneficiado
    );

    if (index !== -1 && index !== null) {
      updatedBeneficiado = {
        ...beneficiadosFormateadosSinDuplicidad[index],
        idBeneficiado: beneficiadoOriginal.idBeneficiado
      };
      beneficiadosFormateadosSinDuplicidad[index] = updatedBeneficiado;
      return updatedBeneficiado;
    }

    updatedBeneficiado = {
      ...beneficiadoOriginal,
      estatus: 0
    };

    // beneficiadosFormateadosSinDuplicidad.push(updatedBeneficiado);
    return updatedBeneficiado;
  });

  let beneficiadosFinales = [ ];

  beneficiadosFormateadosSinDuplicidad.forEach(element => 
  {
    element.estatus = null; 
    element.idBeneficiado = null;
    beneficiadosFinales.push(element);
  });

  beneficiadosOriginales.forEach(element => 
  {
    element.estatus = 0; // Se envían los originales como inactivos
    beneficiadosFinales.push(element);
  });
  
  const bFinal = [];

  // console.log('tipoBeneficio: ', tipoBeneficio);

  beneficiadosFinales.forEach(element => 
  {
    if(tipoBeneficio === 1) // DIRECTO
    {
      bFinal.push(element);
    } else { // OTROS 
      if(existeBenficiadoSujeto)
      {
        if (!(element.estatus === null && element.idBeneficiado == null &&
          ((bFinal.length !== 0) && element.idSujetoObligado === 0)))  
          {
              bFinal.push(element);
          }
      }else{
        /*if (!(element.estatus === null && element.idBeneficiado == null &&
          (bFinal.length !== 0)))  
          {*/
              bFinal.push(element);
          //}
      }
    }
  });

  // console.log('bFinal: ', bFinal);

  return bFinal;
};

const listaElementosUnicos = (arreglo) => {
  const ids = new Set();
  return arreglo.filter((elemento) => {
    if (elemento.idUsuario === null) {
      return true; // Dejamos los elementos con id null
    }
    if (!ids.has(elemento.idUsuario)) {
      ids.add(elemento.idUsuario);
      return true; // Se conserva el elemento con el primer idUsusario
    }
    return false; // Se quita al elemento con id repetido
  });
};

const formatFirmantes = (firmantes, firmantesCatalogo, beneficiadosOriginales) => {
  const firmantesFormateados = firmantes?.map((firmante, index) => {
    const firmanteSeleccionado = firmantesCatalogo.find((f) => f.idUsuario === firmante.firmante);
    return {
      ...beneficiadosOriginales?.[index],
      pkFirmante: index + 1, // Dato arbitrario solicitado por el backend
      idUsuario: firmante.firmante,
      firma: firmante.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
      idTipoFirmante: 1,
      nombre: firmanteSeleccionado.nombre,
      apPaterno: firmanteSeleccionado.apPaterno,
      apMaterno: firmanteSeleccionado.apMaterno,
      puesto: firmanteSeleccionado.puesto,
      numEmpleado: firmanteSeleccionado.numEmpleado
    };
  });
  // No permite la duplicación de los elementos desde la creación.
  return listaElementosUnicos(firmantesFormateados);
};

const formatFirmantesEdicion = (firmantes, firmantesCatalogo, beneficiadosOriginales) => {
  // Se agregan los usuarios de captura manual de móvil, no tienen idUsuario.
  const firmantesEdicion =
    firmantes?.map((firmante, index) => {
      const firmanteSeleccionado =
        firmante.firmante === null
          ? beneficiadosOriginales.find((f) => f.idFirmante === firmante.idFirmante)
          : firmantesCatalogo.find((f) => f.idUsuario === firmante.firmante);
      return {
        ...beneficiadosOriginales?.[index],
        pkFirmante: index + 1, // Dato arbitrario solicitado por el backend
        idUsuario: firmante.firmante,
        firma: firmante.firma?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1],
        idTipoFirmante: 1,
        nombre: firmanteSeleccionado?.nombre || '',
        apPaterno: firmanteSeleccionado?.apPaterno || '',
        apMaterno: firmanteSeleccionado?.apMaterno || '',
        puesto: firmanteSeleccionado?.puesto || '',
        numEmpleado: firmanteSeleccionado?.numEmpleado || ''
      };
    }) || [];

  // Luego, se encuentran los firmantes eliminados
  const firmantesEliminados = beneficiadosOriginales
    .filter((b) => !firmantes.some((f) => f.idFirmante === b.idFirmante))
    .map((beneficiado) => ({
      ...beneficiado,
      estatus: 0 // Se establece el estatus a 0 para el eliminado lógico en BD
    }));

  // Se combinan ambos arreglos
  const firmantesCombinados = [...firmantesEdicion, ...firmantesEliminados];
  // No permite la duplicación de los elementos desde la edición.
  const firmantesTodos = listaElementosUnicos(firmantesCombinados);
  return firmantesTodos;
};

const formatHallazgos = (
  hallazgos,
  tiposHallazgoCatalogo,
  idProcesoEspecifico,
  idEstado,
  tipoBeneficio,
  idMonitoreo,
  idDistritoLoc,
  idDistritoFed,
  idMunicipio,
  idAmbito,
  initialHallazgos,
  estatus,
  motivoCancelacion
) => {
  const hallazgosFormateados = hallazgos?.map((hallazgo, index) => {
    return {
      ...initialHallazgos?.[index],
      pkHallazgo: index + 1, // Dato arbitrario solicitado por el backend
      idProcesoEspecifico,
      idEstado,
      tipoRegistro: TIPO_ACCESO_WEB,
      estatus,
      motivoCancelacion,
      fechaCreacion: dayjs().format(FORMAT_BACKEND),
      idAmbito,
      idTipoHallazgo: hallazgo.tipo_hallazgo,
      tipoHallazgo: tiposHallazgoCatalogo.find((p) => p.idHallazgo === hallazgo.tipo_hallazgo)
        ?.nombreHallazgo,
      otroTipoHallazgo: '',
      tipoBeneficio,
      idMonitoreo,
      idDistritoFed: idDistritoFed || 0,
      idDistritoLoc,
      idMunicipio,
      cantidad: hallazgo.cantidad,
      lema: hallazgo.lema,
      duracionHr: hallazgo.duracionHr,
      duracionMin: hallazgo.duracionMin,
      duracionSeg: hallazgo.duracionSeg,
      modoTiempoLugar: hallazgo.informacion_adicional,
      muestras: [
        {
          ...initialHallazgos?.[index]?.muestras?.[0],
          pkMuestra: 1,
          muestra:
            hallazgo.muestra_1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
            'data:video/mp4;base64'
              ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
              : hallazgo.muestra_1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          ...initialHallazgos?.[index]?.muestras?.[1],
          pkMuestra: 2,
          muestra:
            hallazgo.muestra_2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
            'data:video/mp4;base64'
              ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_2.mp4'
              : hallazgo.muestra_2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          ...initialHallazgos?.[index]?.muestras?.[2],
          pkMuestra: 3,
          muestra:
            hallazgo.muestra_3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
            'data:video/mp4;base64'
              ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_3.mp4'
              : hallazgo.muestra_3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          ...initialHallazgos?.[index]?.muestras?.[3],
          pkMuestra: 4,
          muestra:
            hallazgo.muestra_4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
            'data:video/mp4;base64'
              ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_4.mp4'
              : hallazgo.muestra_4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          ...initialHallazgos?.[index]?.muestras?.[4],
          pkMuestra: 5,
          muestra:
            hallazgo.muestra_5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
            'data:video/mp4;base64'
              ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_5.mp4'
              : hallazgo.muestra_5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        }
      ].filter((m) => m.muestra) // Quitamos los elementos que no tengan media
    };
  });
  return hallazgosFormateados;
};

export const formatoMuestrasHallazgos = (hallazgos) => {
  const hallazgosFormateados = hallazgos?.map((hallazgo, index) => {
    return {
      pkHallazgo: index + 1,
      muestras: [
        {
          pkMuestra: 1,
          muestra: hallazgo.muestra_1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          pkMuestra: 2,
          muestra: hallazgo.muestra_2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          pkMuestra: 3,
          muestra: hallazgo.muestra_3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          pkMuestra: 4,
          muestra: hallazgo.muestra_4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        },
        {
          pkMuestra: 5,
          muestra: hallazgo.muestra_5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
        }
      ].filter((m) => m.muestra) // Quitamos los elementos que no tengan imagen
    };
  });
  return hallazgosFormateados;
};

const actualizaFecha = (fecha1, fecha2) => {
  const fechaBusquedaDay = fecha1?.format(DATE_BACKEND_DAY);
  const horaBusquedaHour = fecha2?.format(DATE_BACKEND_HOUR);
  const fechaFinal = fechaBusquedaDay + horaBusquedaHour;
  return fechaFinal;
};

export const formatoCreacionMonitoreoInternet = (dataFormulario, catalogos) => {
  // Esta estructura es solicitada por backend
  const payloadBase = {
    monitoreos: {
      toTerminate: [],
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toSave: []
    },
    actasInicio: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    actasCierre: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
    , idMonitoreo: 0
    , idTipoMonitoreo: MONITOREOS_INTERNET
  };

  // console.log('dataFormulario.beneficiados: ', dataFormulario.beneficiados);

  const nuevoMonitoreo = {
    pkMonitoreo: 1, // Este valor se queda fijo puede ser lo que sea
    idTipoMonitoreo: MONITOREOS_INTERNET,
    estatusMonitoreo: MONITOREO_TERMINADO.value,
    idProcesoGral: dataFormulario.idProcesoGral,
    descripcionProcesoGral:
      catalogos.data.procesosElectorales?.find(
        (p) => p.idProcesoElectoral === dataFormulario.idProcesoGral
      )?.descripcion || '',
    // descripcionProcesoGral: '', // TODO: ver si es necesario para la edicion
    idTipoEleccion: 2, // No se establece desde el formulario
    idAmbito: dataFormulario.idAmbito,
    idEstado: dataFormulario.idEstado,
    tipoRegistro: TIPO_ACCESO_WEB,
    // idUsuario: 75, // TODO: ver si es necesario
    fechaRegistro: dayjs().format(FORMAT_BACKEND), // Momento de la generacion
    notificarPartido: 0, // No se establece desde el formulario
    formatos: [
      {
        pkFormato: 1, // Dato arbitrario solicitado por el payload
        fechaBusqueda: actualizaFecha(dataFormulario.fecha_busqueda, dataFormulario.hora_busqueda),
        acuerdoCOF: dataFormulario.acuerdo_cof,
        idPlataforma: dataFormulario.plataforma_digital,
        fechaAcuerdoAprobado: dataFormulario.fecha_acuerdo_aprobado?.format(FORMAT_BACKEND),
        otraPlataforma: '', // TODO: falta hacer logica para obtener esta parte
        url: dataFormulario.URL,
        beneficiados: dataFormulario.beneficiados.map((beneficiado) => ({
          ...beneficiado,
          pkBeneficiado: Math.floor(Math.random() * 9)
        })),
        firmantes: formatFirmantes(dataFormulario.firmas, catalogos.data.usuariosFiscalizacion)
      }
    ],
    hallazgos: formatHallazgos(
      dataFormulario.hallazgos,
      catalogos.data.tipoMonitoreos.find((m) => m.idTipoMonitoreo === MONITOREOS_INTERNET)
        ?.tipoHallazgos,
      dataFormulario.idProcesoEspecifico,
      dataFormulario.idEstado,
      dataFormulario.tipo_beneficio,
      null,
      dataFormulario.idDistritoLoc,
      dataFormulario.idDistritoFed,
      dataFormulario.idMunicipio,
      dataFormulario.idAmbito
    )
  };

  payloadBase.monitoreos.toSave.push(nuevoMonitoreo);
  return payloadBase;
};

export const formatoEdicionMonitoreoInternet = (dataFormulario, catalogos, initialData) => 
{
  const payloadBase = {
    monitoreos: {
      toUpdate: [],
      toCancel: []
    },
    hallazgos: {
      toCancel: [],
      toDeValidate: [],
      toValidate: [],
      toUpdate: [],
      toSave: []
    },
    formatos: {
      toCancel: [],
      toUpdate: [],
      toSave: []
    }
    , idMonitoreo: initialData.tableRow.idMonitoreo
    , idTipoMonitoreo: MONITOREOS_INTERNET
  };

  // const initialMonitoreo = initialData?.tableRow || {};
  const initialFormato = initialData?.tableRow?.formatos?.[0] || {};
  const initialHallazgos = initialData?.tableRow.hallazgos || [];

  // const monitoreo = {
  //   pkMonitoreo: initialMonitoreo.pkMonitoreo,
  //   idTipoMonitoreo: initialMonitoreo.idTipoMonitoreo,
  //   estatusMonitoreo: initialMonitoreo.estatusMonitoreo,
  //   idProcesoGral: initialMonitoreo.idProcesoGral,
  //   descripcionProcesoGral: initialMonitoreo.descripcionProcesoGral,
  //   idTipoEleccion: initialMonitoreo.idTipoEleccion,
  //   idAmbito: initialMonitoreo.idAmbito,
  //   idEstado: initialMonitoreo.idEstado,
  //   tipoRegistro: initialMonitoreo.tipoRegistro,
  //   fechaRegistro: initialMonitoreo.fechaRegistro,
  //   notificarPartido: initialMonitoreo.notificarPartido
  // };

  // console.log('dataFormulario.beneficiados: ', dataFormulario.beneficiados);

  const formatos = [
    {
      ...initialFormato,
      pkFormato: 1, // Dato arbitrario solicitado por el payload
      fechaBusqueda: actualizaFecha(dataFormulario.fecha_busqueda, dataFormulario.hora_busqueda),
      acuerdoCOF: dataFormulario.acuerdo_cof,
      idPlataforma: dataFormulario.plataforma_digital,
      fechaAcuerdoAprobado: dataFormulario.fecha_acuerdo_aprobado?.format(FORMAT_BACKEND),
      otraPlataforma: '', // TODO: falta hacer logica para obtener esta parte
      url: dataFormulario.URL,
      beneficiados: newFormatBeneficiados(
        dataFormulario.beneficiados,
        catalogos.data.beneficiados,
        dataFormulario.idProcesoEspecifico,
        initialFormato.beneficiados ,
        dataFormulario.tipo_beneficio
      ),
      firmantes: formatFirmantesEdicion(
        dataFormulario.firmas,
        catalogos.data.usuariosFiscalizacion,
        initialFormato.firmantes
      )
    }
  ];

  const hallazgos = formatHallazgos(
    dataFormulario.hallazgos,
    catalogos.data.tipoMonitoreos.find((m) => m.idTipoMonitoreo === MONITOREOS_INTERNET)
      ?.tipoHallazgos,
    dataFormulario.idProcesoEspecifico,
    dataFormulario.idEstado,
    dataFormulario.tipo_beneficio,
    initialData.tableRow.idMonitoreo,
    dataFormulario.idDistritoLoc,
    dataFormulario.idDistritoFed,
    dataFormulario.idMunicipio,
    dataFormulario.idAmbito,
    initialHallazgos,
    dataFormulario.estatus,
    dataFormulario.motivoCancelacion
  );

  // Se verifica si se eliminaron o actualizaron las muestras
  for (let i = 0; i < initialHallazgos.length; i += 1) {
    const hallazgosForm = dataFormulario.hallazgos[i];
    // Si hallazgos[i] = undefined, quiere decir que se eliminó un hallazgo
    if (dataFormulario.hallazgos[i] !== undefined) {
      // en caso de validar el monitoreo, se verifica si el hallazgo estaba cancelado
      // se verifican cambios en la muestra 1
      if (hallazgosForm.muestra_1?.file && initialHallazgos[i].muestras[0] !== undefined) {
        initialHallazgos[i].muestras[0].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[0]);
        if (hallazgosForm.muestra_1?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 1,
            muestra:
              hallazgosForm.muestra_1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
              'data:video/mp4;base64'
                ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                : hallazgosForm.muestra_1?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 2
      if (hallazgosForm.muestra_2?.file && initialHallazgos[i].muestras[1] !== undefined) {
        initialHallazgos[i].muestras[1].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[1]);
        if (hallazgosForm.muestra_2?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 2,
            muestra:
              hallazgosForm.muestra_2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
              'data:video/mp4;base64'
                ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                : hallazgosForm.muestra_2?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 3
      if (hallazgosForm.muestra_3?.file && initialHallazgos[i].muestras[2] !== undefined) {
        initialHallazgos[i].muestras[2].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[2]);
        if (hallazgosForm.muestra_3?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 3,
            muestra:
              hallazgosForm.muestra_3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
              'data:video/mp4;base64'
                ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                : hallazgosForm.muestra_3?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 4
      if (hallazgosForm.muestra_4?.file && initialHallazgos[i].muestras[3] !== undefined) {
        initialHallazgos[i].muestras[3].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[3]);
        if (hallazgosForm.muestra_4?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 4,
            muestra:
              hallazgosForm.muestra_4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
              'data:video/mp4;base64'
                ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                : hallazgosForm.muestra_4?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
      // se verifican cambios en la muestra 5
      if (hallazgosForm.muestra_5?.file && initialHallazgos[i].muestras[4] !== undefined) {
        initialHallazgos[i].muestras[4].estatus = 0;
        hallazgos[i].muestras.push(initialHallazgos[i].muestras[4]);
        if (hallazgosForm.muestra_5?.file?.status !== 'removed') {
          const newMuestra = {
            pkMuestra: 5,
            muestra:
              hallazgosForm.muestra_5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[0] ===
              'data:video/mp4;base64'
                ? '/data/user/0/com.mx.ine.simac_web/app_web/media/muestra_1.mp4'
                : hallazgosForm.muestra_5?.fileList[0]?.originFileObj?.fullBase64Img?.split(',')[1]
          };
          hallazgos[i].muestras.push(newMuestra);
        }
      }
    } else {
      initialHallazgos[i].estatus = 3;
      initialHallazgos[i].pkHallazgo = i + 1;
      initialHallazgos[i].eliminado = 1;
      hallazgos.push(initialHallazgos[i]);
    }
  }
  // Verifica si se cambió el estatus. Si es cancelado se envía a cancelar el monitoreo
  if (dataFormulario.estatus !== initialHallazgos[0].estatus && dataFormulario.estatus === 3) {
    // payloadBase.hallazgos.toCancel = hallazgos;
    payloadBase.monitoreos.toCancel = [
      {
        pkMonitoreo: initialHallazgos?.[0]?.idMonitoreo,
        idMonitoreo: initialHallazgos?.[0]?.idMonitoreo,
        motivoCancelacion: dataFormulario?.motivoCancelacion
      }
    ];
  }

  const monitoreoActualizado = {
    pkMonitoreo: 1, // Este valor se queda fijo puede ser lo que sea
    idTipoMonitoreo: MONITOREOS_INTERNET,
    idMonitoreo: initialData.tableRow.idMonitoreo,
    idEstado: dataFormulario.idEstado,
    idProcesoGral: dataFormulario.idProcesoGral,
    idProcesoEspecifico: dataFormulario.idProcesoEspecifico,
    idMunicipio: dataFormulario.idMunicipio,
    idAmbito: dataFormulario.idAmbito,
    idDistritoLoc: dataFormulario.idDistritoLoc,
    idDistritoFed: dataFormulario.idDistritoFed,
    tipoRegistro: TIPO_ACCESO_WEB,
    estatusMonitoreo: dataFormulario.estatus,
    motivoCancelacion: dataFormulario?.motivoCancelacion !== undefined ? dataFormulario?.motivoCancelacion : ''
  };
  payloadBase.monitoreos.toUpdate.push(monitoreoActualizado);

  payloadBase.hallazgos.toUpdate = hallazgos;
  payloadBase.formatos.toUpdate = formatos;
  return payloadBase;
};

export const formatFromBackToForm = (monitoreo) => {
  return {
    idProcesoGral: monitoreo.idProcesoGral,
    estatus: monitoreo.hallazgos?.[0].estatus,
    motivoCancelacion: monitoreo.hallazgos?.[0]?.motivoCancelacion,
    hallazgos:
      monitoreo.hallazgos?.map((hallazgo) => ({
        tipo_hallazgo: hallazgo.idTipoHallazgo,
        cantidad: hallazgo.cantidad,
        lema: hallazgo.lema,
        duracionHr: hallazgo.duracionHr,
        duracionMin: hallazgo.duracionMin,
        duracionSeg: hallazgo.duracionSeg,
        informacion_adicional: hallazgo.modoTiempoLugar
        // TODO: integrar imagenes
      })) || [],
    idEstado: monitoreo.idEstado,
    idProcesoEspecifico: monitoreo.hallazgos?.[0]?.idProcesoEspecifico,
    idMunicipio: monitoreo.hallazgos?.[0]?.idMunicipio,
    idAmbito: monitoreo.hallazgos?.[0]?.idAmbito,
    acuerdo_cof: monitoreo.formatos?.[0]?.acuerdoCOF,
    fecha_acuerdo_aprobado:
      monitoreo.formatos?.[0]?.fechaAcuerdoAprobado !== '' &&
      monitoreo.formatos?.[0]?.fechaAcuerdoAprobado !== null
        ? dayjs(monitoreo.formatos?.[0]?.fechaAcuerdoAprobado, 'YYYYMMDDHHmmss')
        : null,
    firmas:
      monitoreo.formatos?.[0]?.firmantes?.map((firmante) => ({ firmante: firmante.idUsuario })) ||
      [],
    beneficiados: [],
    idDistritoLoc: monitoreo.hallazgos?.[0]?.idDistritoLoc,
    idDistritoFed: monitoreo.hallazgos?.[0]?.idDistritoFed,
    fecha_busqueda: dayjs(monitoreo.formatos?.[0]?.fechaBusqueda, 'YYYYMMDDHHmmss'),
    hora_busqueda: dayjs(monitoreo.formatos?.[0]?.fechaBusqueda, 'YYYYMMDDHHmmss'),
    plataforma_digital: monitoreo.formatos?.[0]?.idPlataforma,
    URL: monitoreo.formatos?.[0]?.url,
    tipo_beneficio: monitoreo.hallazgos?.[0]?.tipoBeneficio
  };
};
